// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import PayoutsPage from "./pages/PayoutsPage";
import LogsPage from "./pages/LogsPage";
import ShopsPage from "./pages/ShopsPage";
import ShopDetailsPage from "./pages/ShopDetailsPage";
import AffiliatesPage from "./pages/AffiliatesPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/payouts" element={<PayoutsPage />} />
        <Route path="/logs" element={<LogsPage />} />
        <Route path="/affiliates" element={<AffiliatesPage />} />
        <Route path="/shops" element={<ShopsPage />} />
        <Route path="/shop/:shopId" element={<ShopDetailsPage />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    </Router>
  );
}

export default App;
